$(document).ready(function () {
  var windowWidth = $(window).width();
  var windowSize = 768;
  if (windowWidth >= windowSize) {
    $(".shop-inner__size .size").click(function () {
      // $(".shop-inner__size .size").removeClass("active");
      $(this).addClass("active").siblings().removeClass("active");;
      var dataSize = $(this).data("size");
      $(".shop-box").attr("class", "shop-box").addClass(dataSize);
      // Reset transform của $slider
      $(".shop-box__item").each(function (index) {
        // var $slider = $(this).find(".slider-item");
        var $slider = $(this).find(".slider");
        // $slider.slick("slickSetOption", "speed", 300, true);
        // $slider.slick("slickSetOption", "swipe", true); // enable swipe
        // $slider.slick("setPosition"); // reset slider position
        $slider.slick('slickGoTo', 0, true);
      });
    });
  } else {
    $(".shop-inner__size .size").removeClass("active");
    $(".shop-inner__size .size[data-size='small']").addClass("active");
    $(".shop-box").attr("class", "shop-box").addClass("small");
    $(".shop-inner__size .size").click(function () {
      var dataSize = $(this).data("size");
      $(".shop-box").attr("class", "shop-box").addClass(dataSize);
      // Reset transform của $slider
      $(".shop-box__item").each(function (index) {
        // var $slider = $(this).find(".slider-item");
        var $slider = $(this).find(".slider");
        // $slider.slick("slickSetOption", "speed", 300, true);
        // $slider.slick("slickSetOption", "swipe", true); // enable swipe
        // $slider.slick("setPosition"); // reset slider position
        $slider.slick('slickGoTo', 0, true);
      });
    });
  }
});
// function click open popup & accordion

if ($(".js-filter-add").length > 0) {
  $(".js-filter-add").on("click", function () {
    $("body").toggleClass("js-filter-cart");
    $(".box-filter").toggleClass("js-filter-cart");
    var __cur_p = $(window).scrollTop();
    var __cur_h = $("body").outerHeight();
    $("body").attr("data-position", __cur_p);
    $("body").css({
      top: "-" + __cur_p + "px",
      left: 0,
      width: "100%",
      height: __cur_h + "px",
      position: "fixed",
      "z-index": "-1",
      "touch-action": "none",
      "overflow-y": "auto",
    });
  });
  $(".close").click(function () {
    $("body").removeClass("js-filter-cart");
    $(".box-filter").removeClass("js-filter-cart");
    resetBodyStyles();
  });
  $(document).on("click", function (event) {
    if (!$(event.target).closest(".box-filter,.shop-inner__filter,.hamberger,.header-nav__inner,.shop-inner,#wrap").length) {
      $(".box-filter").addClass("active");
      $("body").removeClass("js-filter-cart");
      $(".box-filter").removeClass("js-filter-cart");
      resetBodyStyles();
    } else {
      $(".box-filter").removeClass("active");
    }
  });
} else {
  resetBodyStyles();
}
if ($(".box-filter").length > 0) {
  $(".box-filter .item .ques").on("click", function () {
    if (!$(this).hasClass("active")) {
      $(this).addClass("active");
      $(this).next(".ans").addClass("active").slideDown();
    } else {
      $(this).removeClass("active");
      $(this).next(".ans").removeClass("active").slideUp();
    }
  });
}

/* Filterカスタマイズ */
if ($(".mobile-facets__open").length > 0) {
  $(".mobile-facets__open").on("click", function () {
    $("body").toggleClass("js-filter-cart");
    $("body").removeClass("fixHeader");
    var __cur_p = $(window).scrollTop();
    var __cur_h = $("body").outerHeight();
    $("body").attr("data-position", __cur_p);
    $("body").css({
      top: "-" + __cur_p + "px",
      left: 0,
      width: "100%",
      height: __cur_h + "px",
      position: "fixed",
      "z-index": "-1",
      "touch-action": "none",
      "overflow-y": "auto",
    });
  });
  $(".mobile-facets__close-custom,.btn-href button").click(function () {
    $("body").removeClass("js-filter-cart");
    $("body").addClass("fixHeader");
    $(".disclosure-has-popup").removeClass("menu-opening");
    $(".disclosure-has-popup").removeAttr("open");
    resetBodyStyles();
  });
} else {
  resetBodyStyles();
}
$(".mobile-facets__summary").on("click", function () {
  if (!$(this).hasClass("active")) {
    $(this).addClass("active");
  } else {
    $(this).removeClass("active");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var activeFacets = document.querySelector(".active-facets");
  var control = document.querySelector(".shop-inner__control");
  if (activeFacets && control) {
    control.appendChild(activeFacets);
  }
});
